import state from './moduleVesselReportListState.js'
import mutations from './moduleVesselReportListMutations.js'
import actions from './moduleVesselReportListActions.js'
import getters from './moduleVesselReportListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
